import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListUserDataManagement = async (param) => {
  let url = `${API_URL.Loader}/api/UserDataManagement/GetListUserDataManagement`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetLatestUploadUserData = async (param) => {
  let url = `${API_URL.Loader}/api/UserDataManagement/GetLatestUploadUserData`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListViewUploadDataHistory = async (param) => {
  let url = `${API_URL.Loader}/api/UserDataManagement/GetListViewUploadDataHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListDownloadTemplate = async (param) => {
  let url = `${API_URL.Loader}/api/UserDataManagement/GetListDownloadTemplate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const UploadMasterData = async (param) => {
  let url = `${API_URL.Loader}/api/UserDataManagement/UploadMasterData`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DownloadUserData = async (param) => {
  let url = `${API_URL.Loader}/api/UserDataManagement/DownloadUserData`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};